import React from 'react'

class ColorText extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 10 11">
        <path
          fill="#1B66B3"
          fillRule="evenodd"
          d="M9 9.079v1.511H1V9.08h8zM5.575.59l3.07 7.985h-1.02L6.789 6.36H3.202l-.844 2.215H1.351L4.438.59h1.137zm-.574.922h-.024l-.351 1.074-1.078 2.87h2.894L5.37 2.622 5 1.512z"
        />
      </svg>
    )
  }
}

export default ColorText
